import css from "standard/css";

const style = css`
  :root {
    --font-size-xxxs: 12px;
    --font-size-xxs: 14px;
    --font-size-xs: 16px;
    --font-size-sm: 20px;
    --font-size-md: 24px;
    --font-size-lg: 32px;
    --font-size-xl: 40px;
    --font-size-xxl: 48px;
    --font-size-xxxl: 64px;
    --font-size-display: 80px;
    --font-size-giant: 96px;
  }
`;

export default style;
